const coatingData=[
 {name:'PIXAR UV',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarUv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection']},
 {name:'PIXAR BLUV',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarBluv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection','Blue Light protection']},
 {name:'PIXAR AQUA',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAqua.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},
 {name:'PIXAR DRIVE',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarDrive.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},
 {name:'PIXAR ANTIFOG',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAntifog.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Blue Light protection']}
];

const logos={
 clear:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/clear.png?v=1779777681',
 transitions:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/transitions.png?v=1779777682',
 transitionsX:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/transitionsX.png?v=1779777681',
 nPolar:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/nPolar.png?v=1779777681',
 driveWear:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/driveWear.png?v=1779777681',
 trivex:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/trivex.png?v=1779777681',
 trivexX:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/trivexX.png?v=1779777682',
 qvex:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/qvex.png?v=1779777681',
 qvexwizard:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/qvexwizard.png?v=1779777681',
 wizard:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/wizard.png?v=1779777681',
 pc:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pc.png?v=1779777682',
 pcTransitions:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pcTransitions.png?v=1779777681',
 pcNupolar:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pcNupolar.png?v=1779777681'
};

const spec={
 '1.50':[
  {m:'Clear',logo:logos.clear,title:'Individual free form progressive',abbe:58,density:'1.32',uv:350,thin:'',colors:[],rx:[[-3,5],[-6,8],[-8,8],[-9,12],[-10,12]]},
  {m:'Transitions',logo:logos.transitions,title:'Photochromic, Individual free form progressive',abbe:58,density:'1.32',uv:400,thin:'',colors:['Brown','Smoked'],rx:[[0,0],[0,0],[-10,7],[-11,7],[-12,7]]},
  {m:'Transitions XTRActive',logo:logos.transitionsX,title:'Photochromic, Individual free form progressive',abbe:58,density:'1.32',uv:400,thin:'',colors:['Smoked'],rx:[[0,0],[-6,7],[-10,7],[-11,7],[-12,7]]},
  {m:'NuPolar',logo:logos.nPolar,title:'Polarized, Individual freeform progressive',abbe:58,density:'1.32',uv:400,thin:'',colors:['Brown','Smoked','G15'],rx:[[-3,5],[-6,7],[-7,7],[-8,7],[-9,7]]},
  {m:'DriveWear',logo:logos.driveWear,title:'Photochromic, Individual free form progressive',abbe:58,density:'1.32',uv:400,thin:'',colors:[],rx:[[0,0],[0,0],[-8,7],[-9,7],[-10,7]]}
 ],
 '1.53':[
  {m:'Trivex',logo:logos.trivex,title:'Individual free form progressive',abbe:45,density:'1.11',uv:385,thin:'%35 thinner',colors:[],rx:[[0,0],[-5,6],[-8,8],[-9,8],[-10,8]]},
  {m:'Trivex Transitions',logo:logos.trivexX,title:'Photochromic Individual free form progressive',abbe:45,density:'1.11',uv:400,thin:'%35 thinner',colors:['Smoked'],rx:[[0,0],[-6,6],[-8,8],[-9,8],[-10,8]]}
 ],
 '1.57':[
  {m:'Q-vex',logo:logos.qvex,title:'Individual free form progressive',abbe:46,density:'1.15',uv:400,thin:'%40 thinner',colors:[],rx:[[-3,5],[-4,7],[-10,7],[-11,10],[-10,12]]},
  {m:'Q-vex Wizard',logo:logos.qvexwizard,title:'Photochromic Individual free form progressive',abbe:46,density:'1.15',uv:400,thin:'%40 thinner',colors:[],rx:[[0,0],[-3,6],[-11,6],[-12,6],[-13,6]]}
 ],
 '1.58':[
  {m:'Clear',logo:logos.clear,title:'Individual free form progressive',abbe:38,density:'1.28',uv:380,thin:'%40 thinner',colors:[],rx:[[-3,5],[-4,7],[-10,7],[-11,13],[-12,13]]},
  {m:'Wizard',logo:logos.wizard,title:'Photochromic, Individual free form progressive',abbe:58,density:'1.32',uv:380,thin:'%40 thinner',colors:[],rx:[[0,0],[-10,6],[-11,6],[-12,6],[-13,6]]}
 ],
 '1.59 PC':[
  {m:'PC',logo:logos.pc,title:'Polycarbonate, Individual freeform progressive',abbe:30,density:'1.22',uv:380,thin:'%40 thinner',colors:[],rx:[[0,0],[0,0],[-10,7],[-11,7],[-12,8]]},
  {m:'PC Transitions',logo:logos.pcTransitions,title:'Photochromic Polycarbonate, Individual freeform progressive',abbe:30,density:'1.22',uv:400,thin:'%40 thinner',colors:['Smoked'],rx:[[0,0],[-6,5],[-8,8],[-9,8],[-10,8]]},
  {m:'PC NuPolar',logo:logos.pcNupolar,title:'Polarized Polycarbonate, Individual freeform progressive',abbe:30,density:'1.22',uv:400,thin:'%40 thinner',colors:['Brown','Smoked'],rx:[[0,0],[-7,6],[-8,6],[-9,6],[-10,6]]}
 ],
 '1.61':[
  {m:'Clear',logo:logos.clear,title:'Individual free form progressive',abbe:42,density:'1.30',uv:385,thin:'%45 thinner',colors:[],rx:[[0,0],[-7,8],[-10,11],[-12,11],[-12,11]]},
  {m:'Wizard',logo:logos.wizard,title:'Photochromic, Individual freeform progressive',abbe:42,density:'1.30',uv:400,thin:'',colors:['Brown','Smoked'],rx:[[0,0],[-9,6],[-10,6],[-11,6],[-12,6]]},
  {m:'Transitions',logo:logos.transitions,title:'Photochromic, Individual freeform progressive',abbe:42,density:'1.30',uv:400,thin:'',colors:['Brown','Smoked'],rx:[[0,0],[0,0],[-10,9],[-11,9],[-12,9]]}
 ],
 '1.67':[
  {m:'Clear',logo:logos.clear,title:'Individual free form progressive',abbe:34,density:'1.37',uv:390,thin:'%60 thinner',colors:[],rx:[[0,0],[-9,7],[-10,11],[-11,11],[-12,11]]},
  {m:'Wizard',logo:logos.wizard,title:'Photochromic, Individual freeform progressive',abbe:34,density:'1.37',uv:400,thin:'',colors:['Brown','Smoked'],rx:[[0,0],[-9,6],[-10,6],[-11,6],[-12,6]]},
  {m:'Transitions',logo:logos.transitions,title:'Photochromic, Individual freeform progressive',abbe:34,density:'1.37',uv:400,thin:'',colors:['Brown','Smoked'],rx:[[0,0],[0,0],[-8,10],[-9,10],[-10,10]]},
  {m:'NuPolar',logo:logos.nPolar,title:'Polarized, Individual freeform progressive',abbe:34,density:'1.37',uv:400,thin:'',colors:['Brown','Smoked'],rx:[[0,0],[-10,7],[-11,7],[-12,7],[-13,7]]}
 ],
 '1.74':[
  {m:'Clear',logo:logos.clear,title:'Individual free form progressive',abbe:33,density:'1.47',uv:395,thin:'%65 thinner',colors:[],rx:[[0,0],[0,0],[-15,12],[-16,12],[-17,12]]},
  {m:'Transitions',logo:logos.transitions,title:'Photochromic, Individual free form progressive',abbe:33,density:'1.47',uv:400,thin:'',colors:['Smoked'],rx:[[0,0],[0,0],[-13,11],[-14,11],[-15,11]]}
 ]
};

function renderCoating(i=0){
 const tabs=document.getElementById('coatingTabs');
 const box=document.getElementById('coatingBox');
 if(!tabs || !box) return;

 tabs.innerHTML=coatingData.map((c,n)=>`
  <button class="gt-coating-tab ${n===i?'active':''}" onclick="renderCoating(${n})">
    <img src="${c.img}" alt="${c.name}">
  </button>
 `).join('');

 const icons=['✳','💧','✺','◎','☕','☂','⌁'];

 box.innerHTML=coatingData[i].features.map((f,n)=>`
  <div class="gt-feature">
    <div class="gt-icon">${icons[n]||'✳'}</div>
    ${f}
  </div>
 `).join('');
}

let activeIndex='1.50';
let activeMat=0;

function renderIndex(){
 const indexTabs=document.getElementById('indexTabs');
 const materialTabs=document.getElementById('materialTabs');
 if(!indexTabs || !materialTabs) return;

 indexTabs.innerHTML=Object.keys(spec).map(k=>`
  <button class="gt-index-tab ${k===activeIndex?'active':''}" onclick="activeIndex='${k}';activeMat=0;renderIndex();">
    ${k}
  </button>
 `).join('');

 const mats=spec[activeIndex];

 materialTabs.innerHTML=mats.map((x,i)=>`
  <button class="gt-material-tab ${i===activeMat?'active':''}" onclick="activeMat=${i};renderIndex();">
    <img src="${x.logo}" alt="${x.m}">
  </button>
 `).join('');

 renderSpec(mats[activeMat]);
}

function rxRows(rx){
 const dia=[80,75,70,65,60];
 const minRx=-18;
 const maxRx=14;
 const range=maxRx-minRx;

 return rx.map((r,i)=>{
  if(!r[0]&&!r[1]){
    return `<div class="gt-rx-row"><div class="gt-rx-dia">${dia[i]}</div><div class="gt-rx-track"></div></div>`;
  }

  const left=((r[0]-minRx)/range)*100;
  const width=((r[1]-r[0])/range)*100;

  return `
    <div class="gt-rx-row">
      <div class="gt-rx-dia">${dia[i]}</div>
      <div class="gt-rx-track">
        <div class="gt-rx-fill" style="left:${left}%;width:${width}%">
          <span style="left:-34px">${r[0]}</span>
          <span style="right:-34px">${r[1]>0?'+'+r[1]:r[1]}</span>
        </div>
      </div>
    </div>`;
 }).join('');
}

function getUvDeg(uv){
  if(uv <= 350) return 117;
  if(uv <= 380) return 140;
  if(uv <= 385) return 148;
  if(uv <= 390) return 158;
  if(uv <= 400) return 180;
  return 180;
}

function renderSpec(d){
 const panel=document.getElementById('specPanel');
 if(!panel) return;

 const colors={Brown:'#87613d',Smoked:'#203a36',G15:'#49654b'};

 panel.innerHTML=`
  <div class="gt-spec-title">${d.title}</div>

  <div class="gt-spec-grid">
    <div class="gt-spec-card">
      <div class="gt-spec-label">Index</div>
      <div class="gt-index-visual">
        <div class="gt-index-bracket"></div>
        <div class="gt-big-num">${activeIndex}</div>
      </div>
    </div>

    <div class="gt-spec-card">
      <div class="gt-spec-label">Abbe υe</div>
      <div class="gt-ring">${d.abbe}</div>
    </div>

    <div class="gt-spec-card">
      <div class="gt-spec-label">Density ρ</div>
      <div class="gt-density-wrap">
        <div class="gt-bar"><span style="height:55%"></span></div>
        <div class="gt-density-value">
          <div class="main">${d.density}</div>
          <small>g/m³</small>
        </div>
      </div>
    </div>

    <div class="gt-spec-card">
      <div class="gt-spec-label">Addition</div>
      <div class="gt-addition-wrap">
        <div class="gt-bar"><span style="height:100%"></span></div>
        <div class="gt-addition-value">
          <div class="main">4.00</div>
          <br>
          <div class="main" style="font-size:18px">0.50</div>
        </div>
      </div>
    </div>

    <div class="gt-spec-card">
      <div class="gt-spec-label">UV Cut</div>
      <div class="gt-uv-wrap">
        <div class="gt-uv-arc" style="--uv-deg:${getUvDeg(d.uv)}deg"></div>
        <div class="gt-uv-value">${d.uv}<br>nm</div>
      </div>
    </div>
  </div>

  <div class="gt-rx">
    <div style="text-align:center;font-size:14px;margin-bottom:5px">RX Range</div>
    ${rxRows(d.rx)}
  </div>

  <div class="gt-height-table">
   <div class="gt-height-row">
    <b>Corridor Height (mm)</b>
    ${[5,7,9,11,13,15].map(v=>`<span class="gt-dot ${[5,7,9,11].includes(v)?'active':''}">${v}</span>`).join('')}
   </div>

   <div class="gt-height-row">
    <b>Min. Fitting Height (mm)</b>
    ${[14,16,18,20,22,24].map(v=>`<span class="gt-dot ${[14,16,18,20].includes(v)?'active':''}">${v}</span>`).join('')}
   </div>
  </div>

  <div class="gt-note">
    The highest performance product of Free Form Technology which can be produced for individual measurements. Excellent backside processed individual progressive which is manufactured by calculating varying measurements based on the user’s face ergonomy and the shape of the desired rim by way of MIDPOINT technology.
  </div>

  ${d.title.includes('Photochromic')?'<div class="gt-note">Its photochromic feature protects the eyes from harmful UV radiation.</div>':''}

  ${d.thin?`
    <div class="gt-thin">
      ${d.thin}<br>
      <small>(compared to 1.5 index organic lenses)</small>
    </div>`:''}

  ${d.colors.length?`
    <div class="gt-colors">
      <b>Color Options :</b>
      ${d.colors.map(c=>`${c} <span class="gt-color-dot" style="background:${colors[c]}"></span>`).join(' ')}
    </div>`:''}
 `;
}

function initBA(){
 const box=document.getElementById('baBox');
 const after=document.getElementById('baAfter');
 const slider=document.getElementById('baSlider');
 if(!box || !after || !slider) return;

 function move(e){
  const r=box.getBoundingClientRect();
  const clientX=e.touches?e.touches[0].clientX:e.clientX;
  const x=Math.max(0,Math.min(clientX-r.left,r.width));
  const p=x/r.width*100;
  after.style.width=p+'%';
  slider.style.left=p+'%';
 }

 box.addEventListener('mousemove',move);
 box.addEventListener('touchmove',move,{passive:true});
}

document.addEventListener('DOMContentLoaded',function(){
 renderCoating();
 renderIndex();
 initBA();
});